import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/CustomButtons/Button.js'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import CircularProgress from '@material-ui/core/CircularProgress'

import GridItem from '../../components/Grid/GridItem.js'
import GridContainer from '../../components/Grid/GridContainer.js'

import styles from '../../assets/jss/material-dashboard-pro-react/views/dashboardStyle.js'
import switchStyles from '../../assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js'

const useStyles = makeStyles({
  ...styles,
  ...switchStyles
})

export default function AtlasForm ({ formData, onSubmit, onSuccess }) {
  const classes = useStyles()

  const [formValues, setFormValues] = React.useState(formData)
  const [formErrors, setFormErrors] = React.useState({})
  const [formContent, setFormContent] = React.useState(null)

  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState(false)

  React.useEffect(() => {
  }, [])

  const handleChange = e => {
    const { name, value } = e.target

    setFormValues({
      ...formValues,
      [name]: {
        value: value,
        validator: formValues[name].validator,
        placeholderText: formValues[name].placeholderText
      }
    })
  }

  const handleSubmit = () => {
    if (dialogFormValidator()) {
      setLoading(true)

      // get a response for registering a site
      onSubmit(formValues).then(res => {
        if (res !== undefined) {
          if (!res.success) {
            setFormContent(displayFormErrorMessage(res.code, res.message))
            setError(true)
            setLoading(false)
          } else {
            setError(false)
            setLoading(false)
            onSuccess(1)
          }
        }
      })
    } else {
      setError(false)
      setLoading(false)
    }
  }

  const dialogFormValidator = () => {
    const temp = {}

    Object.keys(formValues).map((key) => {
      temp[key] = (formValues[key].validator).test(formValues[key].value) ? '' : `Invalid ${key}`
    })

    setFormErrors({
      ...temp
    })

    return Object.values(temp).every(x => x === '')
  }

  const displayFormErrorMessage = (code, message) => {
    const displayCode = code
    let displayMsg = message

    // If we want to create custom messages
    // depending on the error code
    switch (code) {
      case 101:
        displayMsg = 'Received invalid data'
    }

    return <div style={{ color: 'red' }}>
      <h4><b>Error: {displayCode}</b></h4>
      <h5>{displayMsg}</h5>
    </div>
  }

  return (<form>
    <GridContainer>
      <GridItem xs={12}>
        <div id="form-main-content">
          <div>
            {Object.keys(formValues).map((key) =>
              (
                <div className={classes.formSpacing} key={key} >
                  <TextField
                    variant="outlined"
                    label={formValues[key].placeholderText}
                    name={key}
                    value={formValues[key].value}
                    {...(formErrors[key] && { error: true, helperText: 'Invalid input' })}
                    onChange={handleChange}/>
                </div>
              ))}
          </div>
          { error &&
            <div id="form-alternate-view" style={{ display: 'block', textAlign: 'center' }}>
              {formContent}
            </div>
          }
        </div>
        <div className={classes.btnRight} style={{ position: 'relative' }}>
          <Button
            id="form-submit-btn"
            variant="outlined"
            color="primary"
            disabled={loading}
            onClick={handleSubmit}
            style={{ width: '85px', height: '40px' }}>
            {
              loading === true ? <CircularProgress size={20} /> : <b>Submit</b>
            }
          </Button>
        </div>
      </GridItem>
    </GridContainer>
  </form>
  )
}

AtlasForm.propTypes = {
  formData: PropTypes.object,
  onSubmit: PropTypes.func,
  onSuccess: PropTypes.func
}
